export default function Footer(){
    return(
        <div>
            <footer>
                ©2022 Lim Zheng Qian. All Rights Reserved.
            </footer>
        </div>
    )
}